export const SHOW = 'Показать';
export const HIDE = 'Скрыть';
